// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bfy_a"};